import {useSelector} from "react-redux";
import {RootState} from "store";
import { WidgetButton, MenuLinkItem, MenuButtonItem } from "./MainHeaderMenuWidgetItems";
import SwitchAccountModal from "./SwitchAccountModal";
import useModal, { openModal } from "ui-utils/useModal"
import { accountMenuDataTest } from 'testUtils'
import {ReactComponent as AccountNameIcon} from "./images/NewAccountIcon.svg";

const AccountIconWrapper = () => <AccountNameIcon style={{width: 28, height: 23}}/>;

const AccountWidget = () => {
    const accountName = useSelector((state: RootState) => state.tenancy.selectedAccount?.accountName);
    const selectedAccount = useSelector((state: RootState) => state.tenancy.selectedAccount);
    const isSwitchAccountModalOpen = useModal("TENANCY/SWITCH-ACCOUNT").isActive;
    if (!accountName) {
        return null;
    }

    return <>
        <WidgetButton Icon={ AccountIconWrapper} dataTestId={accountMenuDataTest.accountButton} label={accountName}  ariaLabel="Account">
            {selectedAccount?.userRole === "Role-1" && <MenuLinkItem dataTestId={accountMenuDataTest.menu.serviceAccountButton} to="/service-accounts">Service accounts</MenuLinkItem>}
            <MenuButtonItem onClick={() => {
                openModal("TENANCY/SWITCH-ACCOUNT")
            }}>Switch account</MenuButtonItem>
        </WidgetButton>
        {isSwitchAccountModalOpen && <SwitchAccountModal/>}
    </>
}

export default AccountWidget;
